<template>
  <div class="container">
   <!--  <nav-bar rightShow="false" @leftClick="leftClick"></nav-bar> -->
    <ul class="content">
      <li class="item" v-for="(item, i) in contents" :key="i">
        <h3 class="title" @click="index = i == index? -1 : i">{{item.title}}</h3>
        <div class="item-content" v-show="i === index" v-html="item.content"></div>
      </li>
    </ul>
  </div>
</template>
<script>
import Common from '../../assets/js/common.js'
import NavBar from '../../components/NavBar/NavBar.vue'
export default {
  components: {
    NavBar
  },
  data () {
    return {
      contents: [
        {title: '如何绑定有品&秒秒测智能健康日历？', content: '1、关注微信公众号【秒秒测】，点击【我的设备】-【智能日历】，进行注册登录，即可进入智能日历设备添加页面；<p>2、按照页面提示进行操作，添加设备。</p>'},
        {title: '如何给有品&秒秒测智能健康日历配置网络？', content: '设备添加成功之后，微信公众号页面会提示是否进行网络配置，点击【需要】按钮，根据提示输入WiFi密码即可。<p>*请确认设备已成功进入了配网模式。</p>'},
        {title: '番茄工作法如何设置？', content: '进入有品&秒秒测智能健康日历设置界面，选择番茄工作法，即可自定义番茄工作法的工作时间和休息时间。<p>*保存时界面会提示激活网络，请根据界面提示操作。</p>'},
        {title: '服药和喝水提醒如何设置？', content: '进入有品&秒秒测智能健康日历设置界面，选择服药/喝水提醒，进入后即可自定义提醒时间和间隔。<p>*保存时界面会提示激活网络，请根据界面提示操作。</p>'},
        {title: '自定义的设置，如服药、喝水、番茄工作法、频道切换等多久可以同步成功？', content: '如之前已经给有品&秒秒测智能健康日历正确配置了网络，联网及同步设置需要约10-30秒。'},
        {title: '如何配置日历的Wi-Fi？', content: '<p>a.进入微信Wi-Fi配置页面（请确保手机当前接入的是2.4GWi-Fi）</p><p>b.长按日历的左键直到出现“成功进入配网模式”</p><p>c.输入Wi-Fi密码</p><p>d.微信配网通过空中接口完成，有一定数据丢失的概率，有时候微信会提示连接超时。遇到此情况请您多试几次。</p><p>e.有些路由器密码较长或较复杂，请您确认输入的密码是正确的</p>'},
        {title: '电池能用多久？', content: '<p>使用时长和电池的容量、日历使用的方式有关</p><p>i.一般的碱性电池能用半年左右，不建议使用碳性电池。</p><p>ii.番茄工作法每分钟都会刷屏，频繁使用番茄工作法会减少电池的使用时长。</p><p>iii.联网时耗电较大，频繁联网也会减少电池使用时长。</p>'},
        {title: '日历的按键逻辑是怎么样的？', content: '<img width="100%" src="' + Common.staticHref() + 'img/keydown.png"/>'},
        {title: '哪些地方的Wi-Fi日历无法接入？', content: '部分公司对个人设备有认证的要求，或者咖啡馆等需要访问网页并输入验证码才能登陆的网络。因为日历无法输入文字，所以无法直接接入这类的网络。'},
        {title: '如果日历不能接入公司或附近的Wi-Fi该怎么办？', content: '<p>日历可以通过您的手机热点或电脑热点接入网络。</p><p>我们的公众号日历设置-》更多设置-》配置备份Wi-Fi，可以帮您快速为日历设置热点。但前提是您的日历目前已经联网了。</p>您也可以在您的电脑上开启热点，让日历接入您的电脑热点。'},
        {title: '如何解绑/删除设备？', content: '秒秒测公众号-》我的设备-》智能日历-》设备列表-》删除设备'},
        {title: '如何重置设备？', content: '方法一: 长按右键15秒 (XX3.8_0099及以上的版本才支持)<br><br>方法二: 依次长按Home、Home、Home、番茄、Home、番茄键，<br>长按的表现为屏幕不刷新但有提示音，<br>重置结束日历显示黄历的页面。'}
      ],
      index: -1
    }
  },
  methods: {
    leftClick () {
      this.$router.back(-1)
    }
  },
  mounted () {
    Common.setTitle('常见问题')
    if (this.$route.query.a == 1)
      this.index = 11
  }
}
</script>
<style lang="stylus" scoped>

.content
/*   margin-top 15px */
  height 100%
  width 100%
  background #ffffff
  box-sizing border-box
  padding 0 20px 20px 33px
  overflow auto
  font-size 15px
  .item
    padding-top 17px
    .title
      color #333333
      line-height 19px
      position relative
    .title::before
      content ''
      width 5px
      height 5px
      border-radius 50%
      background #dfdbdb
      position absolute
      left -11px
      top 4px
    .item-content
      padding-top 10px
      color #666666
      line-height 18px
</style>



// WEBPACK FOOTER //
// src/pages/Question/Question.vue